/* Copyright (C) mroads, LLC - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Premsagar Choudhary <premsagar.choudhary@mroads.com>, December 2020
 * @format
 * @flow
 */

import React from 'react';
import { useSelector } from 'react-redux';
import strings from "../../../../globalization";
import { version } from '../../../../../package.json';
import PopupHeader from '../PopupHeader';
import classes from './About.module.css';
import FireboardUtils from '../../../../util/fireboard-util';

const About = ({ onClose }) => {
  const { storeInfo, deviceApi, currencyInfo } = useSelector(state => state);
  const { supportPhoneNumber, name: storeName, } = storeInfo?.data || {};
  const { deviceName, deviceGroup } = deviceApi?.data || {};
  const { iso2, rnDevEnv } = currencyInfo || {};
  const baseUrl = window.location.origin || '';

  const getEnv = () => {
    const envMode = process.env.REACT_APP_MODE;
    switch (envMode) {
      case 'DEV': return 'Development';
      case 'UAT': return 'UAT';
      case 'STAGE': return 'Stage';
      default: return 'Production';
    }
  }

  const config = [
    { label: strings.storeName, value: storeName, display: true, },
    { label: strings.deviceName, value: deviceName, display: true, },
    { label: strings.deviceGroupName, value: deviceGroup?.name || '', display: true, },
    { label: strings.webVersion, value: version, display: (window.ReactNativeWebView && rnDevEnv) || (!window.ReactNativeWebView), },
    { label: strings.environment, value: getEnv(), display: true, },
    { label: strings.supportCall, value: FireboardUtils.formattedPhoneNumber(supportPhoneNumber, iso2), display: true, },
    { label: strings.doorDashDelivery, value: '(855) 973-1040', display: true, },
    { label: strings.doorDash, value: '(855) 973-1040', display: true, },
    { label: strings.grubhubMarketplace, value: '(877) 585-7878', display: true, },
    { label: strings.uberEats, value: '(833) 275-3287', display: true, },
    { label: strings.url, value: baseUrl, display: window.ReactNativeWebView && rnDevEnv, },
  ]

  return (
    <div className={classes.container}>
      <PopupHeader title={strings.about} onClose={onClose} />
      <div className={classes.itemsContainer}>
        {config.map(each => {
          return each.display ? (
            <div className={classes.item} key={each.label}>
              <span className={classes.labelTextStyle}>{each.label}</span>
              <span className={classes.valueTextStyle}>{each.value}</span>
            </div>
          ) : null
        })}
      </div>
    </div>
  );
};

export default About;
